/**
 * Client mirror of constants/assistantThread.js.
 * Display / local tumbling. The server enforces the same default (and a
 * later settings override).
 */

export const CONTEXT_WINDOW_DEFAULT = 16;
export const CONTEXT_WINDOW_MIN = 4;
export const CONTEXT_WINDOW_MAX = 40;
